module.exports = __webpack_public_path__ + "img/GAMDOM.2c15c159.svg";